<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        {{ 'utilities_EMAIL_LOG_VIEWER' | translate }}
    </h4>
    <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body">
    @if (view$ | async; as emailLogData) {
        <ul class="list-group list-group-flush description-list">
            <li class="list-group-item">
                <span>{{ 'utilities_SUBJECT' | translate }}</span>
                <span>
                    {{ emailLogData.subject }}
                </span>
            </li>
            <li class="list-group-item">
                <span>{{ 'utilities_TOADDRESS' | translate }}</span>
                <span>
                    {{ emailLogData.toAddresses }}
                </span>
            </li>
            @if (emailLogData.ccAddresses != null) {
                <li class="list-group-item">
                    <span>{{ 'MAIL_CC' | translate }}</span>
                    <span>
                        {{ emailLogData.ccAddresses }}
                    </span>
                </li>
            }
            <li class="list-group-item">
                <span>{{ 'utilities_SENTTIME' | translate }}</span>
                <span>
                    {{ emailLogData.sentTime | appdatetime }}
                </span>
            </li>

            @if (emailLogData.textContent != null && emailLogData.htmlContent == null) {
                <li class="list-group-item">
                    <span>{{ 'utilities_TEXTCONTENT' | translate }}</span>
                    <span>
                        {{ emailLogData.textContent }}
                    </span>
                </li>
            }
            @if (emailLogData.sentStatus != 'OK') {
                <li class="list-group-item">
                    <span>
                        {{ 'utilities_EMAIL_NOT_DELIVERED' | translate }}
                    </span>
                    <span>
                        {{ 'emaillog.sentstatus.' + emailLogData.sentStatus | translate }}
                    </span>
                </li>
            }
        </ul>
    }
    <iframe #iframe style="width: 100%; height: 50vh; border: #dee2e6 dashed 2px"></iframe>
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="activeModal.close()" #btnCancel>
        {{ 'reporting_CLOSE' | translate }}
    </button>
</div>
